import { openProjectEditorModal } from '../State/projectEditorModal'

export default (project) => (dispatch) => {

  dispatch(openProjectEditorModal({ project }))

}
